/**
 * <s-back-link> — "Back" arrow that returns the shopper to the page they came from.
 *
 * The inner link points at the parent page (collection, blog, or home), so it still
 * works without JavaScript or when the shopper landed here from outside the store.
 * When the previous page was on this store, a click steps back through history
 * instead, keeping the shopper's scroll position and filters on that page.
 */
class SBackLink extends HTMLElement {
  #ac;

  connectedCallback() {
    const link = this.querySelector('a');
    if (!link) return;

    this.#ac = new AbortController();
    link.addEventListener('click', (event) => this.#goBack(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #goBack(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if (window.history.length < 2 || !document.referrer) return;

    let sameStore = false;
    try {
      sameStore = new URL(document.referrer).origin === window.location.origin;
    } catch {
      sameStore = false;
    }
    if (!sameStore) return;

    event.preventDefault();
    window.history.back();
  }
}

if (!customElements.get('s-back-link')) {
  customElements.define('s-back-link', SBackLink);
}
